import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8605029e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "batch-search-content" }
const _hoisted_2 = { class: "batch-search-title" }
const _hoisted_3 = { class: "batch-search-input" }
const _hoisted_4 = { class: "text-rt mt_30 commit" }

import { ref, nextTick, watch } from 'vue'
import { t } from '@/plugins/i18n'
interface ObjParams {
  key: string;
  value?: string[]
}

export default /*#__PURE__*/_defineComponent({
  props: ['modelValue', 'title', 'placeholder', 'maxlength', 'style', 'class', 'change'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props


const key = ''
const visible = ref(false)
const inputValue = ref([])
const formData = ref('')
const textareaRef = ref()
const options: any = ref([])

watch(() => props.modelValue, (val) => {
  // 111
  //   inputValue.value = val?.join(',')
  inputValue.value = val
}, {
  immediate: true
})

const changInput = (val: string[]) => {
  //   const arr = val?.split(',')
  props.change?.(val)
  emit('update:modelValue', val)
}
// 搜索
const search = () => {
  // 已换行分割
  const arr = formData.value.split(/\n/).filter((v: any) => !!v || (v === 0))
  //   每个元素需要去除处理，然后过滤掉空格的值
  const newArr = arr.map((item) => item.trim())?.filter((v: any) => !!v || (v === 0))
  props.change?.(newArr)
  emit('update:modelValue', newArr)
  visible.value = false
}
// 打开弹窗
const openBatchModal = () => {
  // 需要去除空格然后过滤掉空格的值
  const newInputValueArr = inputValue.value?.map((item: string) => item.trim())?.filter((v: any) => !!v || (v === 0))
  formData.value = newInputValueArr?.join('\n')
  visible.value = true
}
const changeInput = () => {
  formData.value = formData.value
    .split(/\n/)
    .splice(0, 500)
    .join('\n')
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$slots['prepend'])
      ? _renderSlot(_ctx.$slots, "prepend", { key: 0 })
      : _createCommentVNode("", true),
    _createVNode(_component_el_select, {
      style: _normalizeStyle([{"height":"32px"}, _ctx.$props.style]),
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      multiple: "",
      filterable: "",
      "allow-create": "",
      "collapse-tags": "",
      "max-collapse-tags": 3,
      "default-first-option": "",
      "reserve-keyword": false,
      placeholder: __props.placeholder,
      onDblclick: openBatchModal,
      class: _normalizeClass(_ctx.$props.class),
      onChange: changInput,
      "fit-input-width": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputValue.value, (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item,
            label: item,
            value: item
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "style", "class"]),
    _createVNode(_component_el_dialog, {
      "model-value": visible.value,
      "show-close": false,
      width: "500px",
      top: "20vh",
      "destroy-on-close": "",
      onClosed: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('批量搜索')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData).value = $event)),
              placeholder: _unref(t)('每行一个（支持excel复制黏贴）'),
              class: "input",
              onInput: changeInput,
              ref: (_value, _refs) => {
                _refs['textareaRef'] = _value
                textareaRef.value = _value
              }
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
              class: "btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: search,
              class: "btn",
              disabled: !formData.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ], 64))
}
}

})